module.exports = __webpack_public_path__ + "img/37f887a.jpg";